angular.module("ainapp")
    .controller("billwiseAnalysisController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Bill Wise Analysis";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })



            $scope.Init = function () {

                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), 0, 1);


                $scope.filter = {
                    VoucherNo: "",
                    FromDate: startdate,
                    ToDate: new Date(),
                }

                $scope.load = false;
                $scope.isFilter = false;

            }
            $scope.Init();





            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        if ($scope.isFilter) {

                            o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                            o.data.FromDay = $scope.filter.FromDate.getDate();
                            o.data.FromYear = $scope.filter.FromDate.getFullYear();

                            o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                            o.data.ToDay = $scope.filter.ToDate.getDate();
                            o.data.ToYear = $scope.filter.ToDate.getFullYear();

                            o.data.BranchId = $scope.filter.BranchId;
                            //                        o.data.CustomerId = $scope.filter.CustomerId;
                            o.data.VoucherNo = $scope.filter.VoucherNo;
                            //                        o.data.ProductId = $scope.filter.ProductId;


                            MainService.BillWiseDetailsReport(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            ReceiptNo: {
                                type: "string",
                                editable: false,
                            },
                            ReceiptType: {
                                type: "string",
                                editable: false,
                            },
                            "BillWiseAnalysis.Account.Name": {
                                type: "string",
                                editable: false,
                            },
                            "BillWiseAnalysis.INVNo": {
                                type: "string",
                                editable: false,
                            },
                            Credit: {
                                type: "number",
                                editable: false,
                            },
                            Debit: {
                                type: "number",
                                editable: false,
                            },
                            BillDate: {
                                type: "date",
                                editable: false,
                            },
                            //                            DueDate: {
                            //                                type: "date",
                            //                                editable: false,
                            //                            },
                            BillNo: {
                                type: "string",
                                editable: false,
                            },


                            Date: {
                                type: "date",
                                editable: false,
                            },




                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                aggregate: [


                    {
                        field: "Debit",
                        aggregate: "sum"
                        }, {
                        field: "Credit",
                        aggregate: "sum"
                        },




                    ],
            });

            $scope.KendoGridOptions = {


                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [

                    {
                        field: "BillWiseAnalysis.Account.Name",
                        title: "Account",
                        width: "100px",
                        },
                    {
                        field: "BillNo",
                        title: "PO No",
                        width: "100px",
                        },
                    {
                        field: "BillDate",
                        title: "Due Date",
                        template: "#= kendo.toString(kendo.parseDate(BillDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                        },
//                    {
//                        field: "DueDate",
//                        title: "Due Date",
//                        template: '<span>{{dataItem.DueDate | date: "dd/MM/yyyy"}}</span>',
//                        width: "120px",
//                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                        },
                    {
                        field: "ReceiptNo",
                        title: "Receipt #",
                        width: "100px",
                        },
                    {
                        field: "BillWiseAnalysis.INVNo",
                        title: "Voucher #",
                        width: "100px",
                        },
                    {
                        field: "ReceiptType",
                        title: "Type",
                        width: "100px",
                        },
                    {
                        field: "Credit",
                        title: "Credit",
                        width: "100px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Credit, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                        headerTemplate: kendo.template("<div class='headerright'>Credit</div>")
                        },
                    {
                        field: "Debit",
                        title: "Debit",
                        width: "100px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Debit, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                        headerTemplate: kendo.template("<div class='headerright'>Debit</div>")
                        },

                    ],
            };



            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.print = function () {

                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();

                MainService.PrintCPVMasterReport($scope.filter).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


        }])
